export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["card"] = "card";
    PaymentMethod["cash"] = "cash";
})(PaymentMethod || (PaymentMethod = {}));
